export default "__VITE_ASSET__UkpFhOTT__"